import { getLocale } from "../runtime";

const sv_errorsubtitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vi ber om ursäkt för besväret. Ett oväntat fel har inträffat.`
};

const errorsubtitle = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_errorsubtitle(inputs)
	return "errorSubtitle";
};

export { errorsubtitle as "errorSubtitle" };